import { AssetType } from '@tmx/data-access';

export function getUserTypeDisplayNameKey(userType: AssetType | null) {
  return userType === null
    ? 'enums.assetType.AssetId'
    : `enums.assetType.${userType}`;
}

/**
 * t(enums.assetType.AssetId)
 * t(enums.assetType.Email)
 * t(enums.assetType.Phone)
 * t(enums.assetType.VehicleId)
 * t(enums.assetType.DeviceId)
 * t(enums.assetType.DriverId)
 * t(enums.assetType.InventoryId)
 */
